const gitinfo = {
  "commit": "ed73d2d5dcbb307734caa100ed946f0a2db30f5d",
  "abbreviated_commit": "ed73d2d",
  "tree": "7e2c411e89d3a19d699f1d93a331ef9e440d05fa",
  "abbreviated_tree": "7e2c411",
  "parent": "3c59d89ce1c3ab0340dc820341f47c7a0b00059c",
  "abbreviated_parent": "3c59d89",
  "refs": "HEAD -> main, origin/main, origin/HEAD",
  "encoding": "",
  "commit_notes": "",
  "verification_flag": "N",
  "signer": "",
  "signer_key": "",
    "date": "Tue, 30 Dec 2025 16:40:38 -0600"
 }
export default gitinfo;